module.exports = __webpack_public_path__ + "img/h5_game_detail_lucky5_express.29bb6e7a.jpg";